module.exports = __webpack_public_path__ + "main-fonts.f7c56e52c2c44690a0e3.eot";


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/grapesjs/dist/fonts/main-fonts.eot?v=20
// module id = ../../../../grapesjs/dist/fonts/main-fonts.eot?v=20
// module chunks = 2